module.exports = __webpack_public_path__ + "img/1.e63f03f6.png";